/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBridge: {
  name: 'bridge';
  data: string;
} = {
  name: 'bridge',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M304.871 160.111c-81.772 0-153.142 48.377-191.209 120.281H46.42v111.334h134.486c3.79-70.931 57.739-127.237 123.966-127.237s120.176 56.308 123.966 127.237h134.486V280.392H496.08c-38.068-71.904-109.437-120.281-191.209-120.281zM46.42 411.557V591.14h134.624V411.557H46.42zm382.281 0V591.14h134.624V411.557H428.701z"/></svg>`,
};
